import axios from "axios"
import {getConfig} from "./utility";

const initialState = {
    site: {
        site: {},
        persons: [],
        hierarchyUp: [],
        hierarchyDown: [],
        specialties: [],
        kol: [],
        customerSelections: []
    },
    sites: [],
    persons: [],
    fetchingSites: false,
    fetchingPersons: false,
    findingSite: false
};

const SITE_FIND = "SITE_FIND";
const SITES_FETCH = "MASTER_SITES_FETCH";
const PERSONS_FETCH = "DETAIL_PERSONS_FETCH";
const SEARCH = "SEARCH_SITE";

export default (state = initialState, action) => {
    switch (action.type) {
        case SITES_FETCH:
            switch (action.status) {
                case 0:
                    return {...state, fetchingSites: true};
                case 1:
                    return {...state, sites: action.sites, fetchingSites: false};
                default:
                    return {...state, fetchingSites: false}
            }
        case PERSONS_FETCH:
            switch (action.status) {
                case 0:
                    console.log(action);
                    return {...state, fetchingPersons: true};
                case 1:
                    console.log(action);
                    return {...state, persons: action.persons, fetchingPersons: false};
                default:
                    return {...state, fetchingPersons: false}
            }
        case SITE_FIND:
            switch (action.status) {
                case 0:
                    return {...state, findingSite: true};
                case 1:
                    return {...state, site: action.site, findingSite: false};
                default:
                    return {...state, findingSite: false}
            }
        case SEARCH:
            switch (action.status) {
                case 0:
                    return {...state, fetchingSites: true};
                case 1:
                    return {...state, sites: action.sites, fetchingSites: false};
                default:
                    return {...state, fetchingSites: false}
            }
        default:
            return state
    }
}


const getSitesReq = () => ({type: SITES_FETCH, status: 0});
const getSitesSuc = sites => ({type: SITES_FETCH, status: 1, sites});
const getSitesErr = error => ({type: SITES_FETCH, status: -1, error});
export const getSites = () => (dispatch, getState) => {
    dispatch(getSitesReq());
    return axios.get('/site', getConfig(getState))
        .then(res => dispatch(getSitesSuc(res.data)))
        .catch(err => dispatch(getSitesErr(err)))
};

const getPersonsReq = (id) => ({type: PERSONS_FETCH, status: 0, id});
const getPersonsSuc = persons => ({type: PERSONS_FETCH, status: 1, persons});
const getPersonsErr = error => ({type: PERSONS_FETCH, status: -1, error});
export const getPersons = (id) => (dispatch, getState) => {
    dispatch(getPersonsReq(id));
    return axios.get(`/site/${id}/persons`, getConfig(getState))
        .then(res => dispatch(getPersonsSuc(res.data)))
        .catch(err => dispatch(getPersonsErr(err)))
};

const findSiteReq = id => ({type: SITE_FIND, status: 0, id});
const findSiteSuc = site => ({type: SITE_FIND, status: 1, site});
const findSiteErr = error => ({type: SITE_FIND, status: -1, error});
export const findSite = (id) => (dispatch, getState) => {
    dispatch(findSiteReq(id));
    return axios.get(`/site/${id}`, getConfig(getState))
        .then(res => dispatch(findSiteSuc(res.data)))
        .catch(err => dispatch(findSiteErr(err)))
};


const searchReq = request => ({type: SEARCH, status: 0, request});
const searchSuc = sites => ({type: SEARCH, status: 1, sites});
const searchErr = error => ({type: SEARCH, status: -1, error});
export const search = (request) => (dispatch, getState) => {
    dispatch(searchReq(request));
    return axios.post('/site/search', request, getConfig(getState))
        .then(res => dispatch(searchSuc(res.data)))
        .catch(err => dispatch(searchErr(err)))
};


// WEBPACK FOOTER //
// ./src/js/reducers/site.js